import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      flexDirection: 'column',
      fontSize: '2em',
      height: '96%',
      padding: '4vh 2vw',
    },
    paperMoodColor: {
      display: 'flex',
      alignItems: 'right',
      height: '35px',
      minWidth: '50px',
      width: '5vw',
    },
    listStyle: {
      display: 'flex',
      margin: '2vh 0',
      justifyContent: 'center',
      borderColor: 'transparent',
    },
  })
);
